import { render, staticRenderFns } from "./step_3.vue?vue&type=template&id=7b70dc6a&"
import script from "./step_3.vue?vue&type=script&lang=ts&"
export * from "./step_3.vue?vue&type=script&lang=ts&"
import style0 from "./step_3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports